export const TicketTitleSection = ({ title, icon: Icon, children }) => (
    <article
      className="rounded-2xl p-5 sm:p-6 transition-all duration-300"
      style={{
        background: "rgba(15, 23, 42, 0.5)",
        border: "1px solid rgba(51, 65, 85, 0.3)",
        backdropFilter: "blur(12px)",
      }}
    >
      <div className="flex items-center gap-3 mb-5">
        {Icon && (
          <div
            className="w-9 h-9 rounded-lg flex items-center justify-center"
            style={{
              background: "rgba(0, 180, 216, 0.1)",
              border: "1px solid rgba(0, 180, 216, 0.2)",
            }}
          >
            <Icon className="text-ocean-400 text-sm" />
          </div>
        )}
        <h3 className="font-display text-base sm:text-lg font-bold text-gray-100">
          {title}
        </h3>
      </div>
      {children}
    </article>
  );